module.exports = __webpack_public_path__ + "static/img/user3.3094436a.png";